import React from 'react'
import { compose, withProps, withHandlers } from 'recompose'

const buildTabID = year => `price-period-${year}-tab`
const buildPanelID = year => `price-period-${year}-panel`

const enhance = compose(
  withProps(({ selectedYear, pricePeriodYears }) => ({
    tabs: pricePeriodYears.map(year => (
      {
        tabId: buildTabID(year),
        panelId: buildPanelID(year),
        ref: React.createRef(),
        label: year,
        value: Number(year),
        isActive: Number(year) === selectedYear
      }))
  })),
  withHandlers({
    tabAction: ({ onChangeYear, onResetInputToInitialValue }) => tab => {
      onChangeYear(tab.value)
      // Clear periods when switching years
      onResetInputToInitialValue('pricePeriods')
    }
  }),
  withProps(({
    selectedYear,
    selectedPricePeriod,
    pricePeriods,
    pricePeriodYears
  }) => {
    const year = selectedYear && selectedYear.toString()
    const fallbackYear = pricePeriodYears[0]

    // Ensure selectedPricePeriod is an array
    const selectedPeriodsArray = Array.isArray(selectedPricePeriod) ? selectedPricePeriod : []

    if (pricePeriodYears.includes(year)) {
      return {
        pricePeriodOptions: pricePeriods[year],
        pricePeriodSelectedOption: selectedPeriodsArray,
        pricePeriodYear: year
      }
    }

    return {
      pricePeriodOptions: pricePeriods[fallbackYear],
      pricePeriodSelectedOption: [],
      pricePeriodYear: fallbackYear
    }
  }),
  withProps(({ pricePeriodOptions, pricePeriodSelectedOption, pricePeriodYear }) => {
    // Handle multiple selected periods
    if (!Array.isArray(pricePeriodSelectedOption) || pricePeriodSelectedOption.length === 0) {
      return {
        selectedValuesLabel: 'Any Period'
      }
    }

    // If only 'average_monthly_price' is selected, treat as default (no selection)
    if (pricePeriodSelectedOption.length === 1 && pricePeriodSelectedOption[0] === 'average_monthly_price') {
      return {
        selectedValuesLabel: 'Any Period'
      }
    }

    const selectedPeriods = pricePeriodOptions.filter(({ id }) =>
      pricePeriodSelectedOption.includes(id)
    )

    if (selectedPeriods.length === 0) {
      return {
        selectedValuesLabel: 'Any Period'
      }
    }

    // Show count if more than 2 periods selected
    if (selectedPeriods.length > 2) {
      return {
        selectedValuesLabel: `${selectedPeriods.length} Periods ${pricePeriodYear}`
      }
    }

    // Show names for 1-2 periods
    const names = selectedPeriods.map(p => p.shortName).join(', ')
    return {
      selectedValuesLabel: `${names} ${pricePeriodYear}`
    }
  })
)

export { enhance as default, buildTabID, buildPanelID }
